import { styled } from '@1kit/ui/theme'

export const BillingDescription = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  justify-content: center;
`
